<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500" content-class="reserved-dialog-wrapper">
    <v-card class="reserved-dialog" rounded="lg" elevation="6">
      <div class="reserved-dialog__accent"></div>
      <v-card-title class="reserved-dialog__header">
        <v-icon color="secondary" size="30" class="mr-3">mdi-alert-circle</v-icon>
        <span class="text-h6 white--text font-weight-bold">Ya existe un campo fijo con este nombre</span>
      </v-card-title>
      <v-card-text class="reserved-dialog__body text-body-1 text-justify py-6 px-6">
        Ya existe un campo fijo llamado
        <span class="font-weight-bold primary--text">"{{ reservedName }}"</span>
        en los formularios de registro. ¿Estás seguro de crear otro campo con
        un nombre que lo incluye?
      </v-card-text>
      <v-divider class="reserved-dialog__divider"></v-divider>
      <v-card-actions class="reserved-dialog__actions pa-5">
        <v-spacer />
        <v-btn
          text
          class="reserved-dialog__btn-cancel"
          @click="$emit('cancel')"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          rounded
          color="primary"
          class="reserved-dialog__btn-confirm white--text"
          @click="$emit('confirm')"
        >
          Sí, crear de todos modos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ReservedFieldDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reservedName: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.reserved-dialog {
  overflow: hidden;
  position: relative;
}
.reserved-dialog__accent {
  height: 5px;
  background: linear-gradient(90deg, #1b273e 0%, #24b2da 100%);
}
.reserved-dialog__header {
  background-color: #1b273e;
  padding: 20px 24px;
  align-items: center;
}
.reserved-dialog__body {
  color: #4a4a4a;
  line-height: 1.6;
}
.reserved-dialog__divider {
  border-color: #e0e0e0;
}
.reserved-dialog__btn-cancel {
  color: #8c929e;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
}
.reserved-dialog__btn-cancel:hover {
  color: #1b273e;
}
.reserved-dialog__btn-confirm {
  text-transform: none;
  letter-spacing: 0.3px;
  font-weight: 600;
  padding: 0 22px;
}
.reserved-dialog__btn-confirm:hover {
  background-color: #192533 !important;
}
</style>
